import { type FC, type ReactNode } from "react";
import { ChevronsUpDown } from "lucide-react";
import { SelectTrigger } from "~/shared/ui/select";
import { cn } from "~/shared/lib/utils";

/**
 * Shared visual styling for filter form controls (Select trigger, Input).
 * Restores the old admin-filter look: visible filled background instead of the
 * shadcn-default transparent trigger, matching the Combobox trigger styling.
 */
export const FILTER_FIELD_CLASS =
    "bg-input/60 hover:bg-input/80 dark:bg-panel-background dark:hover:bg-input/50 transition-[color,box-shadow,background-color]";

/**
 * Wrapper around base SelectTrigger that hides the built-in single-chevron and
 * renders a double ChevronsUpDown to match the old admin filter look (and the
 * existing Combobox filter trigger). Used locally in DataTableFilter only.
 */
export const FilterSelectTrigger: FC<{ className?: string; children?: ReactNode }> = ({
    className,
    children,
}) => (
    <SelectTrigger
        className={cn(
            // Hide Radix' built-in chevron-down so our own ChevronsUpDown is the only one.
            "[&>svg.lucide-chevron-down]:hidden",
            className,
        )}
    >
        {children}
        <ChevronsUpDown className="size-4 shrink-0 opacity-50" />
    </SelectTrigger>
);
